import axios from 'axios'

const api = () => {
  return axios.create({
    // edit this one
    baseURL: process.env.API_ENDPOINT
  })
}
const state = {
  customers: [],
  customerDetail: [],
  customerDetailHome: [],
  changes: [],
  fields: {
    CUSTNAME: '',
    TYPE: '',
    ROLE: ''
  }
}

const mutations = {
  UPDATE_CUSTOMERS (state, payload) {
    state.customers = payload
  },
  UPDATE_LOGGED_IN (state, payload) {
    state.loggedIn = payload
  },
  GET_CUSTOMER_DETAIL (state, payload) {
    state.customerDetail = payload
  },
  CLEAR_CUSTOMER_DETAIL (state) {
    state.customerDetail = []
  },
  CUSTOMER_DETAIL_HOME (state, payload) {
    state.customerDetailHome = payload
  },
  UPDATE_CUSTOMER_DETAIL (state, payload) {
    state.customerDetail = payload
  },
  ADD_COLLECTIONS_ALLOWED (state, payload) {
    state.customerDetail.CollectionsAllowed.push(payload)
    return state.customerDetail
  },
  REMOVE_COLLECTIONS_ALLOWED (state, payload) {
    let cust = state.customerDetail.CollectionsAllowed
    let ind = cust.findIndex((element) => {
      return element === payload
    })
    cust.splice(ind, 1)
  },
  REMOVE_COLLECTIONS_DISALLOWED (state, payload) {
    let cust = state.customerDetail.CollectionsDisallowed
    let ind = cust.findIndex((element) => {
      return element === payload
    })
    cust.splice(ind, 1)
  },
  ADD_COLLECTIONS_DISALLOWED (state, payload) {
    state.customerDetail.CollectionsDisallowed.push(payload)
  },
  UPDATE_CUSTOMER_CUSTNAME (state, payload) {
    state.customerDetail.Name = payload
  },
  UPDATE_CUSTOMER_TYPE (state, payload) {
    state.customerDetail.Type = payload
  },
  UPDATE_CUSTOMER_ROLE (state, payload) {
    state.customerDetail.Role = payload
  },
  CLEAR_CHANGES (state) {
    state.changes = []
  },
  UPDATE_FIELDS_NAME (state, payload) {
    state.fields.CUSTNAME = payload
  },
  UPDATE_FIELDS_TYPE (state, payload) {
    state.fields.TYPE = payload
  }
}

const actions = {
  getCustomers ({ commit }) {
    api().get('customers')
      .then((response) => {
        commit('UPDATE_CUSTOMERS', response.data.customers)
      })
  },
  getCustomerDetail ({ commit }, cust) {
    let custAdd = 'customer/' + cust
    api().get(custAdd)
      .then((response) => {
        commit('GET_CUSTOMER_DETAIL', response.data.customer)
        commit('CLEAR_CHANGES')
        commit('UPDATE_FIELDS_NAME', response.data.customer.Name)
        commit('UPDATE_FIELDS_TYPE', response.data.customer.Type)
      }).then()
  },
  getLoggedIn ({ commit }, cust) {
    return new Promise((resolve, reject) => {
      let custAdd = 'customer/log/' + cust
      api().get(custAdd)
        .then((response) => {
          commit('UPDATE_LOGGED_IN', response.data.customer)
          resolve(response)
        }).then()
    })
  },
  getCustomerDetailHome ({ commit }, cust) {
    return new Promise((resolve, reject) => {
      let custAdd = 'customer/' + cust
      api().get(custAdd)
        .then((response) => {
          commit('CUSTOMER_DETAIL_HOME', response.data.customer)
          resolve()
        })
    })
  },
  updateCustomer ({ commit }, cust) {
    let custAdd = 'customer/update/' + cust._id
    api().put(custAdd, cust)
      .then((response) => {
        commit('CLEAR_CHANGES')
      }).then()
  },
  addCustomer (context, payload) {
    return new Promise((resolve, reject) => {
      api().post('customer', { Acc: payload.Acc, Name: payload.Name, Type: payload.Type, Auth0Id: payload.Auth0Id }).then((response) => {
        resolve(response)
      }, (error) => {
        reject(error)
      })
    })
  },
  deleteCustomer (context, payload) {
    return new Promise((resolve, reject) => {
      let custAdd = 'customer/delete/' + payload
      api().delete(custAdd, payload)
        .then((response) => {
          resolve(response)
        }, (error) => {
          reject(error)
        })
    })
  },
  adjustCustomerCollections ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      let a = ''
      if (payload.allow === true && payload.restricted === true) { a = 'ADD_COLLECTIONS_ALLOWED' }
      if (payload.allow === false && payload.restricted === true) { a = 'REMOVE_COLLECTIONS_ALLOWED' }
      if (payload.allow === true && payload.restricted === false) { a = 'REMOVE_COLLECTIONS_DISALLOWED' }
      if (payload.allow === false && payload.restricted === false) { a = 'ADD_COLLECTIONS_DISALLOWED' }
      commit(a, payload.id)
      resolve()
    })
  },
  updateCustomerDetail ({ dispatch }, payload) {
    return dispatch('adjustCustomerCollections', payload).then(() => {
      let custAdd = 'customer/update/' + state.customerDetail._id
      api().put(custAdd, state.customerDetail)
        .then((response) => {
        }).then()
        .then({
        }
        )
    })
  }
}
const getters = {
  customers: state => state.customers,
  customerDetail: state => state.customerDetail,
  changes: state => state.changes,
  fields: state => state.fields,
  customerDetailHome: state => state.customerDetailHome,
  loggedIn: state => state.loggedIn
}
const methods = {
}

const customerModule = {
  state,
  mutations,
  actions,
  methods,
  getters
}

export default customerModule
